import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss']
})
export class ContactCardComponent {
  contato = {
    telefone: '(84) 3645-7811',
    whatsapp: '(84) 998726-1070',
    email: 'seplafinancas.parnamirim@gmail.com',
    horarioFuncionamento: '7:30h às 16:00h',
    endereco: 'Rua Castor Vieira Régis, nº50, 1º andar. Cohabinal, Parnamirim- RN, 59140-670'
  }

}
